import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import {
  appendHeaders,
  rawRequest as uiRawRequest,
  rawRequestWithToken as uiRawRequestWithToken,
  rawRequestWithTokenRequired as uiRawRequestWithTokenRequired,
  request as uiRequest,
  requestWithToken as uiRequestWithToken,
  requestWithTokenRequired as uiRequestWithTokenRequired,
  type GraphQLRequestProps,
  type GraphQLRequestWithTokenProps,
  type DefaultVariables,
} from '@repo/ui/src/utils/graphql-request';
import { requestServer as uiRequestServer } from '@repo/ui/src/utils/requestServer';

export {
  defaultUrl,
  type DefaultVariables,
  type GraphQLRequestProps,
  type GraphQLRequestWithTokenProps,
} from '@repo/ui/src/utils/graphql-request';

export const rawRequest = <Data = any, Variables extends DefaultVariables = DefaultVariables>({
  requestHeaders,
  ...rest
}: GraphQLRequestProps<Variables>) =>
  uiRawRequest<Data, Variables>({
    requestHeaders: appendHeaders(requestHeaders as any, {
      'x-commerce-provider': publicRuntimeConfig.commerceProvider,
    }),
    ...rest,
  });

export const rawRequestWithToken = <
  Data = any,
  Variables extends DefaultVariables = DefaultVariables,
>({
  requestHeaders,
  ...rest
}: GraphQLRequestWithTokenProps<Variables>) =>
  uiRawRequestWithToken<Data, Variables>({
    requestHeaders: appendHeaders(requestHeaders as any, {
      'x-commerce-provider': publicRuntimeConfig.commerceProvider,
    }),
    ...rest,
  });

export const rawRequestWithTokenRequired = <
  Data = any,
  Variables extends DefaultVariables = DefaultVariables,
>(
  props: GraphQLRequestWithTokenProps<Variables>,
) =>
  uiRawRequestWithTokenRequired<Data, Variables>({
    ...props,
    requestHeaders: appendHeaders(props.requestHeaders as any, {
      'x-commerce-provider': publicRuntimeConfig.commerceProvider,
    }),
  });

export const request = <Data = any, Variables extends DefaultVariables = DefaultVariables>({
  requestHeaders,
  ...rest
}: GraphQLRequestProps<Variables>) =>
  uiRequest<Data, Variables>({
    requestHeaders: appendHeaders(requestHeaders as any, {
      'x-commerce-provider': publicRuntimeConfig.commerceProvider,
    }),
    ...rest,
  });

export const requestWithToken = <
  Data = any,
  Variables extends DefaultVariables = DefaultVariables,
>({
  requestHeaders,
  ...rest
}: GraphQLRequestWithTokenProps<Variables>) =>
  uiRequestWithToken<Data, Variables>({
    requestHeaders: appendHeaders(requestHeaders as any, {
      'x-commerce-provider': publicRuntimeConfig.commerceProvider,
    }),
    ...rest,
  });

export const requestWithTokenRequired = <
  Data = any,
  Variables extends DefaultVariables = DefaultVariables,
>(
  props: GraphQLRequestWithTokenProps<Variables>,
) =>
  uiRequestWithTokenRequired<Data, Variables>({
    ...props,
    requestHeaders: appendHeaders(props.requestHeaders as any, {
      'x-commerce-provider': publicRuntimeConfig.commerceProvider,
    }),
  });

export const requestServer = <Data = any>(
  props: Parameters<typeof uiRequestServer<Data>>[0],
  config?: Parameters<typeof uiRequestServer<Data>>[1],
) =>
  uiRequestServer<Data>(
    {
      ...props,
      requestHeaders: appendHeaders(props.requestHeaders as any, {
        'x-commerce-provider': publicRuntimeConfig.commerceProvider,
      }),
    },
    config,
  );
